import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'
import { RawLeadActivity } from './types'

export default async function markLeadAsViewedByDealer(leadId: number) {
    try {
        const { data }: { data: RawLeadActivity } = await axios.post(
            `${config.API_BASE_URL}/api/v3/applications/${leadId}/leads-activities/mark-as-viewed/`,
            {},
            {
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to mark lead ${leadId} as viewed.`,
            axiosError,
            {
                leadId,
            },
        )

        throw axiosError
    }
}
